import React from 'react';
import PropTypes from 'prop-types';
import { Link, Switch, Route, withRouter } from 'react-router-dom';
import Cookies from 'js-cookie';

import ConsistencyPage from './SettingsPageComponents/ConsistencySettingsPage.js';

import { READ, WRITE } from './Om7Sense';
import SchedulerSettingsPage
    , {
    ScheduledTaskCreate
} from "./SettingsPageComponents/SchedulerSettingsPage";
import i18next from "i18next";

export class SettingsPage extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        logged_in_as: PropTypes.string,
        gatewayName: PropTypes.string,
        lang: PropTypes.string
    }

    static childContextTypes = {
        basePath: PropTypes.string,
        uuid: PropTypes.string,
        constructTitle: PropTypes.func
    }

    getChildContext() {
        return {
            basePath: this.basePath,
            uuid:this.uuid,
            constructTitle:this.constructTitle
        };
    }

    state = {
        isSubscribed: false,
        config: null
    };

    onAuthenticated() {
        const { t, p } = this.context;
        const self = this;
        const promises = [
            p.subscribePush("config/*"),
            p.subscribePush("status/*")
        ];
        const subPromise = Promise.all(promises);

        subPromise.catch(function (err) {
            console.warn("Cannot subscribe for settings", err);
        }).finally(() => {
            // Check language
            const lang = p.getPath("config/omshepherd/v/language");
            // Compare language set in datastore with what i18next currently has loaded
            if (lang && lang !== i18next.language) {
                // Language has changed, set cookie and reload
                Cookies.set('lang', lang);
                window.location.reload();
            }
            p.subscribeDS("config/omshepherd", function (value, oldValue, relativePath, varName, path) {
                const lang = p.getPath("config/omshepherd/v/language");
                if (lang && lang !== self.context.lang) {
                    // Language has changed, set cookie and reload
                    Cookies.set('lang', lang);
                    window.location.reload();
                }
            });
            self.setState({
                isSubscribed: true,
                config: p.DS.config
            });
        });
    }

    componentDidMount() {
        const p = this.context.p, self = this;

        if (p.isAuthenticated()) {
            this.onAuthenticated();
        } else {
            p.addListener("authenticated", this.onAuthenticated);
        }

        if (this.context.p.isAuthenticated() || this.context.p.hasSessionId()) {
            if (this.props.location.pathname === "/settings") {
                this.props.history.replace( { pathname: "/settings/general" } );
            }
        }

        import(/* webpackChunkName: "SettingsPageComponents/SettingsSubPages.jsx" */ './SettingsPageComponents/SettingsSubPages.jsx').then(({ default: _ }) => {
            self.setState( { SettingsSubPages: _ });
        });
    }

    componentWillUnmount() {
        const p = this.context.p;
        if (this.state.isSubscribed) {
            p.unsubscribePush("config/*");
            p.unsubscribePush("status/*");
            this.setState({isSubscribed: false});
        }
        p.removeListener("authenticated", this.onAuthenticated);
    }

    render() {
        if (!this.state.isSubscribed) {
            return null;
        }

        if (!this.state.SettingsSubPages) {
            return (
                <div className="wrapper devices">
                    <div className="loader-element">
                        <div className="loading loading-lg"></div>
                    </div>
                </div>
            );
        }

        const SettingsSubPages = this.state.SettingsSubPages;

        const t = this.context.t, p = this.context.p;
        
        var getClassForVisibleSection = function (thisRouteUrl) {
            if (window.location.pathname === thisRouteUrl) {
                return "active";
            }
            return "";
        };
        let subpages = [];
        if (this.context.p.checkPermission(READ, "config/network/eth0") && this.state.config?.network?.eth0) {
            subpages.push((
                <li key="network" className={getClassForVisibleSection("/settings/network")}><Link to="/settings/network"><h5>{t('settings.network')}</h5></Link></li>
            ));
        }
        if (this.context.p.checkPermission(READ, "api/pue")) {
            subpages.push((
                <li key="pue" className={getClassForVisibleSection("/settings/pue")}><Link to="/settings/pue"><h5>{t('settings.pue')}</h5></Link></li>
            ));
        }
        if (this.context.p.checkPermission(READ, "config/omweb")) {
            subpages.push((
                <li key="webaccess" className={getClassForVisibleSection("/settings/webaccess")}><Link to="/settings/webaccess"><h5>{t('settings.web_access')}</h5></Link></li>
            ));
        }
        if (this.state.config.omshepherd && this.context.p.checkPermission(READ, "connections")) {
            subpages.push((
                <li key="devices" className={getClassForVisibleSection("/settings/devices") + " " + getClassForVisibleSection("/settings/connection_import")}><Link to="/settings/devices"><h5>{t('settings_devices.header')}</h5></Link></li>
            ));
        }
        if (this.state.config.omsql && this.context.p.checkPermission(READ, "config/omsql")) {
            subpages.push((
                <li key="remotesqlserver" className={getClassForVisibleSection("/settings/remotesqlserver")}><Link to="/settings/remotesqlserver"><h5>{t('settings.sql')}</h5></Link></li>
            ));
        }
        if (this.state.config.omsyslog && this.context.p.checkPermission(READ, "config/omsql")) {
            subpages.push((
                <li key="remotesyslog" className={getClassForVisibleSection("/settings/remotesyslog")}><Link to="/settings/remotesyslog"><h5>{t('settings.syslog')}</h5></Link></li>
            ));
        }
        if (this.state.config.omsnmp && this.context.p.checkPermission(READ, "config/omsql")) {
            subpages.push((
                <li key="snmp" className={getClassForVisibleSection("/settings/snmp")}><Link to="/settings/snmp"><h5>{t('settings.snmp_agent')}</h5></Link></li>
            ));
        }
        if (this.state.config.snmpClient && this.context.p.checkPermission(READ, "config/snmpClient")) {
            subpages.push((
                <li key="snmp_client" className={getClassForVisibleSection("/settings/snmp_client")}><Link to="/settings/snmp_client"><h5>{t('settings.snmp_client')}</h5></Link></li>
            ));
        }
        if (this.state.config.omsmtp && this.context.p.checkPermission(READ, "config/omsql")) {
            subpages.push((
                <li key="email" className={getClassForVisibleSection("/settings/email")}><Link to="/settings/email"><h5>{t('settings.email')}</h5></Link></li>
            ));
        }
        if (this.state.config.backup && this.context.p.checkPermission(READ, "config/backup")) {
            subpages.push((
                <li key="backup" className={getClassForVisibleSection("/settings/backup")}><Link to="/settings/backup"><h5>{t('settings.backup')}</h5></Link></li>
            ));
        }
        if (this.state.config.notifications && this.context.p.checkPermission(READ, "config/notifications")) {
            subpages.push((
                <li key="notifications" className={getClassForVisibleSection("/settings/notifications")}><Link to="/settings/notifications"><h5>{t('settings.notifications')}</h5></Link></li>
            ));
        }
        if (this.context.p.checkPermission(READ, "auth_groups") && this.context.p.checkPermission(READ, "roles")) {
            subpages.push((
                <li key="auth" className={getClassForVisibleSection("/settings/auth")}><Link to="/settings/auth"><h5>{t('settings_auth.header')}</h5></Link></li>
            ));
        }
        if (this.context.p.checkPermission(WRITE, "config/auth")) {
            subpages.push((
                <li key="ldap" className={getClassForVisibleSection("/settings/ldap")}><Link to="/settings/ldap"><h5>{t('settings_auth.header_ldap')}</h5></Link></li>
            ));
        }
        if (this.context.p.checkPermission(READ, "apiv2/groups/clean")) {
            subpages.push((
                <li key="consistency" className={getClassForVisibleSection("/settings/consistency")}><Link to="/settings/consistency"><h5>{t('settings.consistency')}</h5></Link></li>
            ));
        }
        if (this.context.p.checkPermission(READ, "apiv2/scheduler")) {
            subpages.push((
                <li key="scheduler" className={getClassForVisibleSection("/settings/scheduler")}><Link to="/settings/scheduler"><h5>{t('settings.scheduler')}</h5></Link></li>
            ));
        }
        // <li className={getClassForVisibleSection("/settings/firmware")}><Link to="/settings/firmware"><h5>{t('settings.firmware')}</h5></Link></li>
        return (
            <div className="settings content">
                <div className="columns">
                    <ul className="navigation nav__settings cf column col-2">
                        <li className={getClassForVisibleSection("/settings/general")}><Link to="/settings/general"><h5>{t('settings.general')}</h5></Link></li>
                        {subpages}
                    </ul>
                    <div className="device-settings column col-10">
                        <Switch>
                            <Route path="/settings/general" component={SettingsSubPages.general} />
                            <Route path="/settings/network" component={SettingsSubPages.network} />
                            <Route path="/settings/snmp" component={SettingsSubPages.snmp} />
                            <Route path="/settings/firmware" component={SettingsSubPages.firmware} />
                            <Route path="/settings/backup" component={SettingsSubPages.backup} />
                            <Route path="/settings/pue" component={SettingsSubPages.pue} />
                            <Route path="/settings/ldap" component={SettingsSubPages.ldap} />
                            <Route path="/settings/webaccess" component={SettingsSubPages.webaccess} />
                            <Route path="/settings/notifications" component={SettingsSubPages.notifications} />
                            <Route path="/settings/devices" component={SettingsSubPages.devices} />
                            <Route path="/settings/connection_import" component={SettingsSubPages.devicesImport} />
                            <Route path="/settings/connectivity" component={SettingsSubPages.connectivity} />
                            <Route path="/settings/remotesqlserver" component={SettingsSubPages.sql} />
                            <Route path="/settings/remotesyslog" component={SettingsSubPages.syslog} />
                            <Route path="/settings/snmp_client" component={SettingsSubPages.snmp_client} />
                            <Route path="/settings/email" component={SettingsSubPages.email} />
                            <Route path="/settings/auth" component={SettingsSubPages.auth} />
                            <Route path="/settings/consistency" render={() => (<ConsistencyPage t={t} p={p} />)} />
                            <Route path="/settings/scheduler/create/:reportId" component={ScheduledTaskCreate} />
                            <Route path="/settings/scheduler" render={() => (<SchedulerSettingsPage t={t} p={p} />)} />
                        </Switch>
                    </div>
                </div>
                <p className="meta">
                    {t('copyright')} {t('om7.copyright_year')}&nbsp;<a href={t('om7.om7_company_url')}>{t('om7.om7_company')}</a>
                </p>
            </div>
        );
    }
};
